import { IconButton, Stack, Typography } from '@mui/material';

import DeleteIconBordered from '../../../../../../components/svgs/DeleteIconBordered';
import { LIST_ROW_BG_SX, LIST_ROW_BORDER_SX } from '../../../../../common';
import { DISCHARGE_REASON_DELETE_ICON_SIZE } from '../constants';
import {
  DISCHARGE_REASON_ROW_BORDER_SX,
  DISCHARGE_REASON_ROW_LABEL_SX,
  DISCHARGE_REASON_ROW_SX,
} from '../styles';
import { getDischargeReasonRowLabel } from '../utils';

import type { DischargeReasonRowProps } from './types';

export default function DischargeReasonRow({
  reason,
  index,
  disabled,
  showDelete,
  onDelete,
}: DischargeReasonRowProps) {
  const label = getDischargeReasonRowLabel(reason);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={[
        DISCHARGE_REASON_ROW_SX,
        LIST_ROW_BORDER_SX,
        DISCHARGE_REASON_ROW_BORDER_SX,
        LIST_ROW_BG_SX[index % 2],
      ]}
    >
      <Typography sx={DISCHARGE_REASON_ROW_LABEL_SX}>{label}</Typography>
      {showDelete ? (
        <IconButton
          aria-label={`Delete ${label}`}
          disabled={disabled}
          onClick={() => onDelete(reason)}
          size="small"
          sx={{ p: 0 }}
        >
          <DeleteIconBordered
            width={DISCHARGE_REASON_DELETE_ICON_SIZE}
            height={DISCHARGE_REASON_DELETE_ICON_SIZE}
          />
        </IconButton>
      ) : null}
    </Stack>
  );
}
